import apiClient from './base/apiClient'

export interface ReviewCategory {
  id: number
  name: string
  created_at: string
}

export interface GetReviewCategoriesResponse {
  categories: ReviewCategory[]
}

export interface CreateReviewCategoryRequest {
  name: string
}

export interface CreateReviewCategoryResponse {
  message: string
  category: ReviewCategory
}

export const reviewCategoryApi = {
  getCategories: async (): Promise<GetReviewCategoriesResponse> => {
    const response = await apiClient.get<GetReviewCategoriesResponse>(
      '/review-categories'
    )
    return response.data
  },
  createCategory: async (
    data: CreateReviewCategoryRequest
  ): Promise<CreateReviewCategoryResponse> => {
    const response = await apiClient.post<CreateReviewCategoryResponse>(
      '/review-categories',
      {
        name: data.name,
      }
    )
    return response.data
  },
}
